import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, FormControl, Select, MenuItem } from '@mui/material';
import PrimaryButton from '../../../components/Button/Button';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import moment from 'moment';
import * as XLSX from "xlsx";
import { useClient } from '../../../reactQuery/client';
import { useLeadCompliance } from '../../../reactQuery/leadCompliance';
import { useBuildings } from '../../../reactQuery/building';

function SpreadsheetAnnualNotice() {
    const [loading,setLoading]= useState(false);
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear);

    const {
       isLoading,
       error,
       responseData,
       isError,
       refetch,
       totalRecords,
       isRefetching,
    } = useClient({
       pagination: false,
    });

    const { responseData: buildings } = useBuildings
    ({
      pagination: false,
    });

      const prepareQueryFilters = `?year=${selectedYear}&status=pending&pagination=false`;

      const {
        responseData: leadComplianceData,
        refetch: refetchLeadCompliance,
      } = useLeadCompliance(prepareQueryFilters, "SpreadsheetAnnualNotice");

      useEffect(() => {
        refetchLeadCompliance();
      }, [selectedYear]);

    const createExcelObject = () => {
      const exportObject = leadComplianceData?.map((el) => {
        const client = responseData?.find(
          (item) => item.client_id === el.client_id
        );
        const building = buildings?.find(
          (item) => item.building_id === el.building_id
        );
        return {
          Client: el.client,
          Email: client?.user?.email,
          Phone_Number: client?.user?.phone_number,
          Building_address: el.building_address,
          Apartment: el.unit_number,
          City: building?.city,
          State: building?.state,
          Zip_Code: building?.zip_code,
          Year: el.compliance?.compliance_year,
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(exportObject); // Convert JSON data to worksheet
      const workbook = XLSX.utils.book_new(); // Create a new workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1"); // Append the worksheet
      XLSX.writeFile(workbook, `Outstanding-Annual-Notices-${selectedYear}.xlsx`); // Export the workbook to an Excel file

      setLoading(false);
    };

    const handleExcelReport = () => {
        setLoading(true);
        createExcelObject();
    }
  return (
    <Box className="report-card-content">
      <Typography variant="body2" className="report-description">
        Download a spreadsheet with mailing addresses of all units, across all
        buildings and clients, that have outstanding annual notices.
      </Typography>
      <Box className="report-action">
        <FormControl className="year-select">
          <Select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="select-box"
          >
            {Array.from({ length: 6 }, (_, i) => {
              const year = currentYear + 1 - i;
              return (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <PrimaryButton
          className="capitalize primary-btn-class"
          sx={{ height: "36px", boxShadow: "none" ,width: "100%"}}
          variant="contained"
          onClick={handleExcelReport}
          startIcon={<FileDownloadOutlinedIcon />}
          disabled={loading}
        >
          Excel Report
        </PrimaryButton>
      </Box>
    </Box>
  );
}

export default SpreadsheetAnnualNotice